module.exports = __webpack_public_path__ + "img/tutorial-f00-02.2af84fb9.png";